<template>
  <v-container>
    <label>
      <b>{{ $t('levels.level_information') }}</b>
    </label>
    <v-layout row wrap>
      <v-flex xs12 sm4>
        <v-text-field
          :error-messages="typeLevelErrors"
          v-model="levelForm.typeLevel"
          counter="50"
          maxlength="50"
          @input="emitUpdate"
          :label="$t('levels.name')"
          placeholder="Nombre"
          outline
          required
          :disabled="disableFields"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field
          :error-messages="abbrErrors"
          v-model="levelForm.abbr"
          @input="emitUpdate"
          :label="$t('levels.abbreviation')"
          placeholder="Abreviación"
          outline
          maxlength="3"
          mask="NNN"
          counter
          required
          :disabled="disableFields"
        ></v-text-field>
      </v-flex>
      <!-- <v-flex xs12 sm4>
        <v-menu
          ref="clock"
          v-model="modals.clock"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="levelForm.departureTime"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :error-messages="departureTimeErrors"
              outline
              label="Hora de salida"
              placeholder="hh:mm"
              prepend-icon="access_time"
              readonly
              v-on="on"
              :value="departureTimeFixed"
              :disabled="userPermissions['ADD_LEVELS'] ? false : true"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="modals.clock"
            v-model="levelForm.departureTime"
            @input="emitUpdate"
            full-width
            format="24hr"
            @click:minute="$refs.clock.save(levelForm.departureTime)"
            color="secondary"
            header-color="primary"
            use-seconds
            scrollable
          ></v-time-picker>
        </v-menu>
      </v-flex> -->
      <v-flex xs12 sm4>
        <div class="border-class">
          <div class="title-picker">
            <label>{{ $t('levels.dismissal') }}</label>
          </div>
          <div class="datePicker">
            <v-icon class="clock" color="gradiente">schedule</v-icon>
            <span
              v-if="showRedirectToCustomHours"
              @click="onRedirectToCustomHours"
              class="custom-redirect-link"
              >Personalizado por día</span
            >
            <vue-timepicker
              v-else
              :value="fixPMamDate(levelForm.departureTime)"
              @input="emitUpdate"
              class="pickPolls picker"
              format="hh:mm a"
              color="secondary"
              header-color="primary"
              manual-input
              @change="changeTimeF"
              :disabled="disableFields"
            >
            </vue-timepicker>
          </div>
        </div>
      </v-flex>
      <v-flex xs12 text-xl-center>
        <v-checkbox
          :disabled="!lAdding"
          v-model="levelForm.isExtra"
          :label="$t('levels.extracurricular_level')"
          color="secondary"
          hide-details
        ></v-checkbox>
      </v-flex>
      <v-flex xs12 sm4 offset-sm4 v-if="lAdding">
        <v-btn
          :disabled="loading"
          round
          block
          color="gradiente"
          dark
          @click="createLevel"
        >
          {{ $t('generic.save') }}
        </v-btn>
      </v-flex>
      <v-flex xs12 sm4 offset-sm4 v-if="!lAdding">
        <v-btn
          :disabled="userPermissions['DELETE_LEVELS'] ? false : true"
          round
          block
          color="gradiente"
          dark
          @click="modals.confirm = true"
        >
          Eliminar
        </v-btn>
      </v-flex>
    </v-layout>
    <confirm
      v-model="modals.confirm"
      @desition="desition"
      title="Eliminar nivel"
      description="¡Aviso!. Este proceso es <b>destructivo</b>,
    por lo que no podrá recuperar la información eliminada. <br> Se eliminarán los grados y los grupos dentro del nivel.<br> ¿Estás seguro que deseas continuar con la operación?"
    ></confirm>
  </v-container>
</template>

<script>
import VueTimepicker from 'vue2-timepicker'
import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import confirm from '../../Dialogs/Confirm'

// CSS
import 'vue2-timepicker/dist/VueTimepicker.css'
export default {
  validations: {
    levelForm: {
      departureTime: { required },
      typeLevel: { required },
      abbr: { required },
    },
  },
  components: {
    confirm,
    VueTimepicker,
  },
  props: [
    'lAdding',
    'lvl',
    'lUpdate',
    'lEditing',
    'userPermissions',
    'doors',
    'showRedirectToCustomHours',
    'customScheduleHrsOptions',
  ],
  watch: {
    customScheduleHrsOptions() {
      this.levelForm = {
        ...this.levelForm,
        ...this.customScheduleHrsOptions,
      }
    },
    lUpdate() {
      if (this.lUpdate) {
        this.updateLevel()
      }
    },
    lAdding() {
      if (this.lAdding) {
        this.$v.$reset()
      }
    },
    lvl() {
      this.userPermissionFieldsHandler()
      this.levelForm = this.lvl
      if (this.levelForm.customSchedule === true) {
        this.showRedirectToCustomHours = true
      } else {
        this.showRedirectToCustomHours = false
      }
    },
    doors() {
      this.levelForm.doors = this.doors
    },
  },
  data: () => ({
    levelForm: {
      customSchedule: false,
      departureTime: '',
      typeLevel: '',
      abbr: '',
      isExtra: false,
      doors: [],
      minutesLate: 0,
      scheduleDays: [
        {
          dayOfWeek: 1,
          startTime: '08:00:00',
          endTime: '18:00:00',
        },
      ],
    },
    counter: 0,
    loading: false,
    modals: {
      clock: false,
      confirm: false,
    },
    disableFields: false,
  }),
  methods: {
    userPermissionFieldsHandler() {
      if (this.lAdding) {
        this.disableFields = this.userPermissions['ADD_LEVELS'] ? false : true
        return
      }
      if (this.lEditing) {
        this.disableFields = this.userPermissions['UPDATE_LEVELS']
          ? false
          : true
        return
      }
    },
    onRedirectToCustomHours() {
      this.$emit('goToCustomHours')
    },
    createLevel() {
      this.$v.levelForm.$touch()
      if (!this.$v.levelForm.$invalid) {
        this.$emit('loading')
        this.loading = true
        var obj = this.levelForm
        obj.branch = {
          id: this.getBranch.id,
        }
        this.$store
          .dispatch('level/createLevel', obj)
          .then((response) => {
            this.$emit('success')
            this.loading = false
          })
          .catch((error) => {
            this.$emit('error')
            this.loading = false
          })
      }
    },
    updateLevel() {
      if (!this.levelForm.doors.length) {
        this.$emit('sUpdate')
        this.$emit('error', 1128)
        return
      }
      this.$v.levelForm.$touch()
      if (!this.$v.levelForm.$invalid) {
        this.$emit('loading')
        this.$store
          .dispatch('level/updateLevel', this.levelForm)
          .then((response) => {
            console.log(this.levelForm)
            this.$emit('sUpdate')
            this.$emit('successUpdate')
          })
          .catch((error) => {
            this.$emit('sUpdate')
            this.$emit('error', error.data ? error.data.code : null)
          })
      }
    },
    desition(event) {
      if (event) {
        this.$emit('loading')
        this.$store
          .dispatch('level/deleteLevel', this.levelForm)
          .then((response) => {
            this.$emit('success')
            this.$emit('deleted')
          })
          .catch((error) => {
            this.$emit('error', error.data ? error.data.code : null)
          })
      }
    },
    emitUpdate() {
      this.$emit('flagUpdate')
    },
    fixPMamDate(departureTime2) {
      var digitos = departureTime2.replaceAll(':', '')
      if (digitos.length == 6) {
        //obteniendo valores
        var hora = digitos.substring(0, 2)
        var minutos = digitos.substring(2, 4)
        // var segundos = digitos.substring(4,6);
        var amPM = ''
        var prefZero = '0'
        if (hora == '00') {
          hora = 12
          amPM = 'am'
        } else if (hora < 12) {
          amPM = 'am'
        } else if (hora == 12) {
          amPM = 'pm'
        } else if (hora > 12) {
          hora = hora - 12
          if (hora >= 22) {
            amPM = 'pm'
          } else {
            hora = prefZero.concat(hora)
            amPM = 'pm'
          }
        }
        //return hora+":"+minutos+":"+segundos+" "+amPM;
        return hora + ':' + minutos + ' ' + amPM
      } else {
        return '12:00 am'
      }
    },
    changeTimeF(eventData) {
      var hora = eventData.data.hh
      var type = eventData.data.a

      if (type == 'am') {
        if (hora == 12) hora = '00'
      } else if (type == 'pm') {
        if (hora == 12) hora = '12'
        else hora = Number(hora) + 12
      }
      //let time = hora+":"+eventData.data.mm+":"+eventData.data.ss;
      let time = hora + ':' + eventData.data.mm + ':00'
      this.levelForm.departureTime = time
    },
  },
  computed: {
    departureTimeFixed() {
      return this.levelForm.departureTime != null
        ? this.levelForm.departureTime.split(':')[0] +
            ':' +
            this.levelForm.departureTime.split(':')[1]
        : ''
    },
    typeLevelErrors() {
      const errors = []
      if (!this.$v.levelForm.typeLevel.$dirty) return errors
      !this.$v.levelForm.typeLevel.required && errors.push('Nombre obligatorio')

      return errors
    },
    abbrErrors() {
      const errors = []
      if (!this.$v.levelForm.abbr.$dirty) return errors
      !this.$v.levelForm.abbr.required && errors.push('Abreviación obligatoria')
      return errors
    },
    departureTimeErrors() {
      const errors = []
      if (!this.$v.levelForm.departureTime.$dirty) return errors
      !this.$v.levelForm.departureTime.required &&
        errors.push('Hora de salida obligatoria')
      return errors
    },
    ...mapGetters(['getBranch']),
  },
}
</script>

<style>
.vue__time-picker-dropdown ul li:not([disabled]).active,
.vue__time-picker-dropdown ul li:not([disabled]).active:focus,
.vue__time-picker-dropdown ul li:not([disabled]).active:hover,
.vue__time-picker .dropdown ul li:not([disabled]).active,
.vue__time-picker .dropdown ul li:not([disabled]).active:focus,
.vue__time-picker .dropdown ul li:not([disabled]).active:hover {
  background: #63336d;
}

.pickPolls .vue__time-picker input.display-time {
  /* border: 1px solid #d2d2d2;
	width: 10em;
	padding: .3em .5em;
	font-size: 1em; */
  border: 1px solid #fa0000;
}

.border-class {
  border: 2px solid #757575;
  height: 57px;
}

.title-picker {
  font-size: 12px;
  width: 100%;
}

.datePicker {
  font-size: 1.4em;
  display: flex;
  margin-top: -10px;
}

.clock {
  justify-content: center;
  align-items: center;
  margin-left: 10px;
}

.picker {
  justify-content: center;
  align-items: center;
}

.vue__time-picker input.display-time {
  width: 100%;
  border: 0px;
  padding: 0%;
  margin-left: 10px;
  justify-content: center;
  align-items: center;
  outline: none;
}

.vue__time-picker {
  display: flex;
  width: 100%;
}
</style>

<style scoped>
.custom-redirect-link {
  color: #ed565b;
  font-size: 16px;
  text-decoration: underline;
  cursor: pointer;
}
</style>
